:host {
  /* This variable is intentionally left blank. Used within <aha-progress-step> to specify the default length of connecting lines. */
  --aha-progress-steps--line-length: ;

  /* This is intentionally left blank. For CSS variables this serves as a boolean switch, and is activated by the :host([pulse]) ruble below. */
  --aha-progress-steps--pulse: ;
  --aha-progress-steps--pulse-style: double;

  --aha-progress-steps--number-width: 1.6em;
  --aha-progress-steps--line-width: calc(var(--aha-progress-steps--number-width) / 5);
  --aha-progress-steps--cutout-size: calc(1.5 * var(--aha-progress-steps--line-width));

  display: block;
  line-height: 1;
}
:host([pulse]) {
  --aha-progress-steps--pulse: '';
}
:host([pulse-style='dotted']) {
  --aha-progress-steps--pulse-style: dotted;
}
:host([pulse-style='dashed']) {
  --aha-progress-steps--pulse-style: dashed;
}
:host([pulse-style='solid']) {
  --aha-progress-steps--pulse-style: solid;
}
